import { ApiClientError } from '~/ApiClient';

import { Error } from './Error';
import { GroupFinalCalculation, mapGroupFinalCalculation, RawGroupFinalCalculation } from './GroupFinalCalculation';
import { mapError } from './mapError';

export interface Group {
	readonly reference: {
		readonly referenceBasketVersion: string;
		readonly historicProductDataViewDate: Date | null;
		readonly possibleSavingsRelativeTo: string[];
	};
	readonly productLists: ProductList[];
	readonly finalCalculation: GroupFinalCalculation;
}

export interface ProductList {
	readonly dosageStrength: number | null;
	readonly packageSize: number | null;
	readonly productList: { readonly id: string };
	readonly selected: boolean;
	readonly usualTherapeuticDailyDose: number | null;
	readonly usualTherapeuticDailyDosePerPackage: number | null;
	readonly emptyResultReason: Error[];
}

export interface RawGroup {
	readonly reference: {
		readonly referenceBasketVersion: string;
		readonly historicProductDataViewDate: string | null;
		readonly possibleSavingsRelativeTo: string[];
	};
	readonly productLists: RawProductList[];
	readonly finalCalculation: RawGroupFinalCalculation;
}

export interface RawProductList {
	readonly dosageStrength: number | null;
	readonly packageSize: number | null;
	readonly productList: { readonly id: string };
	readonly selected: boolean;
	readonly usualTherapeuticDailyDose: number | null;
	readonly usualTherapeuticDailyDosePerPackage: number | null;
	readonly emptyResultReason: ApiClientError[];
}

export const mapGroup = (group: RawGroup): Group => ({
	...group,
	reference: {
		...group.reference,
		historicProductDataViewDate:
			group.reference.historicProductDataViewDate !== null
				? new Date(group.reference.historicProductDataViewDate)
				: null,
	},
	productLists: group.productLists.map((list) => ({
		...list,
		emptyResultReason: list.emptyResultReason.map(mapError),
	})),
	finalCalculation: mapGroupFinalCalculation(group.finalCalculation),
});
